<template>
	<div class="allbox">
			<minhead :headtitle="juestitle"></minhead>
		<el-dialog title="添加成员" :visible.sync="openaddnewmember" :close-on-click-modal="false" width="650px" v-dialogDrag>
			<!-- <minhead :Stringtitle="'添加成员'" :isdiag="true"></minhead> -->
			<div class="horizontally">
				<el-transfer  :titles="['未选择成员', '已选择成员']" filter-placeholder="请输入用户"
				 v-model="isaddatall" :data="adddataall">
				</el-transfer>
			</div>
			<div slot="footer" style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="openaddnewmember = false" >取 消</div>
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="forsure()">确 定</div>
			</div>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button @click="openaddnewmember = false">取 消</el-button>
				<el-button type="primary" @click="forsure">确 定</el-button>
			</div> -->
		</el-dialog>
		<el-dialog title="新建分组" :visible.sync="opengroup" :close-on-click-modal="false" width="400px" v-dialogDrag>
			<!-- <minhead :Stringtitle="'新建分组'" :isdiag="true"></minhead> -->
			<div class="topstyle">
				<el-input v-model="newgroup" autocomplete="off" style="width: 300px;"></el-input>
			</div>
			<div slot="footer" style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="opengroup = false" >取 消</div>
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="foraddRoleGroup()">确 定</div>
			</div>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button @click="opengroup = false">取 消</el-button>
				<el-button type="primary" @click="foraddRoleGroup()">确 定</el-button>
			</div> -->
		</el-dialog>

		<el-dialog title="新建角色" :visible.sync="openrolegroup" :close-on-click-modal="false" width="550px" v-dialogDrag>
			<!-- <minhead :Stringtitle="'新建角色'" :isdiag="true"></minhead> -->
			<el-form :model="rolegroupform" :rules="rulesSaveRole" ref="roleFrom">
				<el-form-item label="角色名" label-width="120px" prop="roleName"><el-input  v-model="rolegroupform.roleName" autocomplete="off" style="width: 300px;"></el-input></el-form-item>
				<el-form-item label="角色组" label-width="120px" prop="roleGroupId">
					<el-select v-model="rolegroupform.roleGroupId"  placeholder="请选择当前角色组"   style="width: 300px;">
						<el-option v-for="(item,index) in rolalist" :key="index" :label="item.groupName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="角色类型" label-width="120px" prop="roleType">
					<el-select v-model="rolegroupform.roleType"  placeholder="请选择当前角色组"   style="width: 300px;">
						<el-option v-for="(item,index) in roleTypeList()" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述" label-width="120px"><el-input v-model="rolegroupform.description" autocomplete="off" style="width: 300px;"></el-input></el-form-item>
			</el-form>
			<div slot="footer" style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="openrolegroup = false" >取 消</div>
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="addroleserver()">确 定</div>
			</div>
		<!-- 	<div slot="footer" class="dialog-footer">
				<el-button @click="openrolegroup = false">取 消</el-button>
				<el-button type="primary" @click="addroleserver">确 定</el-button>
			</div> -->
		</el-dialog>

	<!-- 	<div style="border-bottom: 1px solid #CCCCCC; padding: 25px 15px;box-sizing: border-box;margin-bottom: 15px;">
			<el-breadcrumb>
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i>
					角色权限
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div> -->

		<div style="display: flex;">
			<div class="ara1">
				<div class="halfclass" v-show="false">
					<el-breadcrumb-item>当前集团</el-breadcrumb-item>
				<!--  <el-select v-model="nowgroup" placeholder="请选择集团"  @change="changegroup">
						<el-option v-for="item in AllCompanyGrouplist" :key="item.id" :label="item.groupName" :value="item.id"></el-option>
					</el-select> -->
					<el-input disabled v-model="useropj.companyGroupName" class="input-with-select" style="width:200px;"></el-input>
				</div>
				<!--<div class="halfclass">
					<el-breadcrumb-item>当前公司</el-breadcrumb-item>
					<el-select v-model="nowcolom" placeholder="请选择公司"  @change="changecolom">
						<el-option v-for="item in AllCompanylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>-->
                <!--  TODO 按钮置灰而不是隐藏 -->
				<div style="display: flex;margin-top: 20px;" v-show='"3" !== useropj.roleType'>
					<!-- <el-button type="primary" plain icon="el-icon-edit" @click="foraddgroup">新建分组</el-button> -->
					<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="foraddgroup">
						<samp>	新建分组
						<i class="el-icon-edit"></i></samp>
					</div>
					<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="foraddrole">
						<samp>	新建角色
						<i class="el-icon-edit"></i></samp>
					</div>
					<!-- <el-button type="success" plain icon="el-icon-edit" @click="foraddrole" >新建角色</el-button> -->
				</div>
				<div class="treeall">

					<el-tree :data="datax"    node-key="id" :default-expand-all="true"  @node-click="handleNodeClick">
					      <div class="custom-tree-node" slot-scope="{ node, data }">
					        <span>{{data.label}}</span>
					       <span  >
					          <el-button
					            type="text"
					            size="mini"
					            @click="() => remove(node, data)" v-show='data.groupType !== "0" && (!data.roleType || useropj.roleType < data.roleType)'>
					            删除
					          </el-button>
							  <el-button  type="text" style="margin-left: 30px;"
					            size="mini" @click="foraddmenber(node, data)" v-if="data.type=='1' && useropj.roleType < data.roleType">添加/移除成员</el-button>
					        </span>
					      </div>
					    </el-tree>
				</div>
			</div>
			<div class="ara2" v-show='this.roleType'>
				<div class="halfclass" v-if="rightitle!=''||rightitlebz!=''">
					<el-breadcrumb-item v-if="rightitle!=''">{{rightitle}}</el-breadcrumb-item>
				<!--  <el-select v-model="nowgroup" placeholder="请选择集团"  @change="changegroup">
						<el-option v-for="item in AllCompanyGrouplist" :key="item.id" :label="item.groupName" :value="item.id"></el-option>
					</el-select> -->

					<div style="opacity: 0.2;"  v-if="rightitlebz!=''">{{rightitlebz}}</div>
				</div>
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
					<el-menu-item index="1">角色成员</el-menu-item>
					<el-menu-item index="2" :disabled="roleid==''?true:false">功能权限</el-menu-item>
				</el-menu>
				<div v-if="chooseindex == 1">
					<div class="ara2-half">
						<el-input v-model="likeSearchvalue" prefix-icon="el-icon-search" placeholder="姓名,用户名,手机号,邮箱" style="width: 230px;" clearable @input="changeserch"></el-input>
						<div>
							<!-- <el-button type="info" icon="el-icon-delete" @click="fordelete">批量删除</el-button> -->

						</div>
					</div>
					<div class="bottomhalf">
						<el-table max-height="500" ref="multipleTable" :data="userdata" style="width: 100%" @selection-change="changeselection">
							<!-- <el-table-column type="selection" width="55"></el-table-column> -->
							<el-table-column prop="userName" label="姓名" width="120"></el-table-column>
							<el-table-column prop="userCode" label="用户名" width="120"></el-table-column>
							<el-table-column prop="phone" label="手机号" show-overflow-tooltip></el-table-column>
							<el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
					<div class="buttompage">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:page-sizes="[10, 20, 100, 500]"
							:key="elementui_page_component_key"
							:current-page="currentpage"
							:page-size="pagenum"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalcount"
						></el-pagination>
					</div>
				</div>
				<div v-if="chooseindex == 2" >
					<div class="buttombut">
						<el-button type="primary" icon="el-icon-edit" @click="forsave" >保存</el-button>
						</div>
					<div class="treeall">
						<el-tree
						:default-expand-all="true"
						  :data="meauall"
						  show-checkbox
						  :default-checked-keys="cheackall"
						  node-key="id"
						   ref="tree"
						  :props="defaultProps">
						</el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {

		return {
			adddataall: [],
			isaddatall: [],
			juestitle:['系统设置', '角色权限'],
			openrolegroup: false,

			opengroup: false,
			openaddnewmember: false,
			chooseindex: 1,
			userdata: [

			],
			activeIndex: '1',



			// AllCompanyGrouplist:[],
			AllCompanylist:[],
			nowcolom:"",
      nowCompany:"",
			newgroup: '',
			rolalist:[
			],
			roleTypeList(){
				if (this.useropj.roleType == 0){
                    return [
						{"name":"集团管理员","id":"1"},
                        {"name":"实体管理员","id":"2"},
                        {"name":"一般用户","id":"3"}
                    ]
                }else
                if (this.useropj.roleType == 1){
                    return [
                        {"name":"实体管理员","id":"2"},
                        {"name":"一般用户","id":"3"}
                    ]
                }else {
                    return [
                        {"name":"一般用户","id":"3"}
                    ]
                }
            },
			rolegroupform: {
				roleName: '',
				description: '',
				roleGroupId: '',
				roleType:''
			},

			datax:[],
			page:1,
			pagenum:10,
			likeSearchvalue:"",
			useropj:'',
			roleid:'',
			roleType:'',
			totalcount:"",
			deletecommids:"",
			cheackall:[
			],
			meauall:[],
			 defaultProps: {
			  children: 'children',
			  label: 'label'
			},
			rightitle:"",
			rightitlebz:"",
			checkTree:{},
			rulesSaveRole: {
				roleGroupId: [{ required: true, message: '请选择角色组', trigger: 'blur' }],
				roleName: [{ required: true, message: '请填写角色名', trigger: 'blur' }],
				roleType: [{ required: true, message: '请填写角色名', trigger: 'blur' }],
			},
			currentpage:1,
			elementui_page_component_key:""
		};

	},
	created() {
		this.useropj=JSON.parse(localStorage.getItem('useropj'))
			this.getAllCompanyGroup()
			this.getGroupCompanyList(this.useropj.companyGroupId)
			this.nowcolom=this.useropj.companyGroupId;
      this.nowCompany=this.useropj.currCompany.id;
			this.getRoleListData(this.nowcolom);

	},
	mounted() {
		document.querySelector('body').setAttribute('style', 'background-color:white');
	},
	methods: {
		/* 保存 */
		forsave(){
		    console.log(this.roleid);
		    // return;
			this.saveRoleMeunFunction(this.$refs.tree.getCheckedKeys())
		  /* console.log(this.$refs.tree.getCheckedKeys()); */
		},
		/* 多选删除 */
		changeselection(e) {
			this.deletecommids = '';
			e.forEach((item, index) => {
				this.deletecommids = this.deletecommids + item.id + ',';
			});
			var reg = /,$/gi;
			this.deletecommids = this.deletecommids.replace(reg, '');
		},
		handleSizeChange(val) {
			this.pagenum=val
			this.getUserListByRole(this.roleid)
		},
		handleCurrentChange(val) {
			this.page=val
			this.getUserListByRole(this.roleid)
		},
		/* 搜索 */
		changeserch(e) {
			this.currentpage=1
			this.elementui_page_component_key++
			this.page=1
			this.likeSearchvalue = e;
			this.getUserListByRole(this.roleid)
		},
		foraddmenber(node, data){
			this.isaddatall=[]
			this.adddataall=[]
			this.openaddnewmember=true
			this.getGroupUserList(this.useropj.companyGroupId)
			this.getExsitsUserByRole(node.key)
		},
		forsure(){
			var arr=''
			this.isaddatall.forEach(item=>{
				this.adddataall.forEach(gtem=>{
					if(item==gtem.key){
						arr+=gtem.key+",";
					}
				})
			})
			this.saveUserRole(arr)
		},
		/* 选择子节点 */
		handleNodeClick(data){
		    // if (data.children){
            //     this.handleNodeClick(data.children[0]);
            // }
			this.checkTree=JSON.parse(JSON.stringify(data));
			this.rightitle=data.label
			this.rightitlebz=data.desc
			this.roleid=data.id
            this.roleType = data.roleType
			if(data.type=="1"){
				this.getUserListByRole(data.id)
				this.getRoleMenuFunctionList(this.roleid)
			}

		},

	/* 	保存角色 */
		saveUserRole(arr){
			let params = {
				roleId:this.roleid,
				ids:arr
				};
			this.$https.fetchPost('sys/admin/saveUserRoleByCompany', params).then(res => {
				if (res.data.success) {
					this.getUserListByRole(this.roleid)
					this.openaddnewmember = false;
				}

			});
		},


		fordelete() {
			this.$confirm('此操作将批量删除用户, 否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		remove(node, data) {
			this.$confirm('是否删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					if(data.type=="1"){
						this.deleteRole(data.id)
					}else{
					this.deleteRoleGroup(data.id)
					}


				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		handleSelect(key) {
			this.chooseindex = key;
			console.log(key);
			if(key==2){
				if(this.roleid==""){
					this.$message({
						type: 'error',
						message: '请选择角色'
					});
					return false
				}
				this.getRoleMenuFunctionList(this.roleid)
			}
		},

		/* 选择公司 */
		changecolom(){
			this.getRoleListData(this.nowcolom);
		},
	/* 	新增角色组弹框弹出 */
		foraddgroup(){
			if(this.nowcolom==""){
				this.$message({
					type: 'error',
					message: '请选择公司'
				});
				return false
			}
			this.newgroup=""
			this.opengroup=true
		},
		/* 新增角色弹出 */
		foraddrole(){
			if(this.nowcolom==""){
				this.$message({
					type: 'error',
					message: '请选择公司'
				});
				return false
			}
		Object.keys(this.rolegroupform).map(key => (this.rolegroupform[key] = ''));
		this.getGroupListData(this.nowCompany)
		this.openrolegroup = true
		},
		/* 确认新增角色组 */
		foraddRoleGroup(){
			if(this.newgroup==""){
				this.$message({
					type: 'error',
					message: '角色组不能为空'
				});
				return false
			}
			this.addRoleGroup(this.nowcolom,this.newgroup)
		},

	/* 	接口调用操作 */

		/* 获取全部用户 */
		getGroupUserList(id){
			let params = id;
			this.$https.fetchPost('sys/admin/getCompanyGroupUserListByCompany', params).then(res => {
                this.adddataall =  this.adddataall.concat(res.data.obj)
				var arr=[]

				let arrback=res.data.obj
				arrback.forEach(item=>{
					arr.push(item.key)
				})
				//	this.isaddatall=arr
			});
		},

		/* 获取公司下角色列表 */
		getRoleListData(id){
			this.$https.fetchPost('sys/admin/getRoleListData', {groupId:id}).then(res => {
                res.data.obj[0].children = res.data.obj[0].children.filter(item => item.roleType != '1')
                console.log(res.data.obj)
				this.datax = res.data.obj
				if(res.data.obj[0].children.length>0){
					this.getUserListByRole(res.data.obj[0].children[0].id)
					this.rightitle=res.data.obj[0].children[0].label
					this.rightitlebz=res.data.obj[0].children[0].desc
				}

			});

		},
		/* 保存角色权限 */
		saveRoleMeunFunction(json){
			if (this.checkTree.type!=1){
				this.$message.error("只能给角色添加权限");
			}
			let params ={
				checkNodes:JSON.stringify(json) ,
				roleId:this.roleid,
				//companyId:this.nowcolom

			}
			this.$https.fetchPost('sys/admin/saveRoleMeunFunctionById', params).then(res => {
                this.getCurrentUserMenuFunction();
			});

			},
        /* 	获取用户展示权限菜单 */
        getCurrentUserMenuFunction() {
            let params = {};
            this.$https.fetchPost('sys/admin/getRoleMenuIdListByUser', params).then(res => {
                if (res.data.success) {
                    localStorage.setItem('routearr', res.data.obj.routearr);
                    localStorage.setItem('userFunction', JSON.stringify(res.data.obj.userFunction));
                    this.saveStorageButton(res.data.obj.userFunction);
                    this.$router.push('/');
                }
            });
        },
        saveStorageButton(data){
            let buttonIds = [];
            let userFunction = data;
            for (let i = 0; i < userFunction.length; i++) {
                if (userFunction[i].hasOwnProperty("children")) {
                    let pageButtons = userFunction[i].children;
                    for (let j = 0; j < pageButtons.length; j++) {
                        if (pageButtons[j].hasOwnProperty("buttomroute")) {
                            let keys= Object.keys(pageButtons[j].buttomroute);
                            if (keys.length <= 0){continue}
                            let buttonObjs = pageButtons[j].buttomroute;
                            for (let key of keys) {
                                buttonIds.push(key);
                                let btnKeys= Object.keys(buttonObjs[key]);
                                if (btnKeys.length <= 0){continue}
                                for (let btnKey of btnKeys) {
                                    if (buttonObjs[key][btnKey]) {
                                        buttonIds.push(btnKey);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            localStorage.setItem('buttonIds', JSON.stringify(buttonIds));
        },
		/* 新增角色 */
		addroleserver(){
			this.$refs['roleFrom'].validate(valid => {
				console.log(valid);
				if (valid) {
					let params ={
						companyGroupId:this.nowcolom,
						roleGroupId:this.rolegroupform.roleGroupId,
						roleName:this.rolegroupform.roleName,
						description:this.rolegroupform.description,
						roleType:this.rolegroupform.roleType
					}
					this.$https.fetchPost('sys/admin/saveRole', params).then(res => {
						if (res.data.success) {
							this.getRoleListData(this.nowcolom);
							this.openrolegroup = false;
						}
					});
				}
			});

			},

		/* 新增角色组 */
		addRoleGroup(companyId,groupName) {
			let params = {
				companyGroupId:companyId,
				groupName:groupName,
				groupType:0

			};
			this.$https.fetchPost('sys/admin/saveRoleGroupByType', params).then(res => {
				if (res.data.success) {

					this.getRoleListData(this.nowcolom);
					this.opengroup = false;
				}

			});
		},
		/* 删除角色组 */
		deleteRoleGroup(id){
			let params = id;
			this.$https.fetchPost('sys/admin/deleteRoleGroupByType', params).then(res => {
				if (res.data.success) {
					this.getRoleListData(this.nowcolom);
					this.userdata=""
					this.cheackall=""
					this.opengroup = false;
				}
			});

			},
			/* 删除角色 */
			deleteRole(id){
				let params = id;
				this.$https.fetchPost('sys/admin/deleteRole', params).then(res => {
					if (res.data.success) {
						this.getRoleListData(this.nowcolom);
						this.userdata=""
						this.cheackall=""
						this.opengroup = false;
					}

				});

				},

		/* 新增角色组 */
		addRole(companyId,groupName) {
			let params = {
				companyId:companyId,
				groupName:groupName
			};
			this.$https.fetchPost('sys/admin/addRole', params).then(res => {
				if (res.data.success) {
					this.opengroup = false;
				}

			});
		},

			/* 获取集团列表 */
			getAllCompanyGroup() {
				let params = {};
				this.$https.fetchPost('sys/admin/getAllCompanyGroup', params).then(res => {
					this.AllCompanyGrouplist = res.data.obj;

				});
			},
			/* 根据角色找到集团用户 */
			getUserListByRole(id) {
				if(id==""||id==null){
					this.$message.error(this.$tolertJSON[4015]);
					return false
				}
				let params = {
					search: {roleId:id},
					likeSearch: this.likeSearchvalue,
					page: this.page,
					limit: this.pagenum
				};
				this.$https.fetchPost('sys/admin/getUserListByRoleByCompany', params).then(res => {
					this.totalcount=res.data.count
						this.userdata=res.data.data
				});
			},
				/* 根据公司查询已存在角色用户 */
			 getExsitsUserByRole (id){
				let params =id
				 console.log(params);
				this.$https.fetchPost('sys/admin/getExsitsUserByRole', params).then(res => {
					var arr=[]
					let arrback=res.data.obj
                    this.adddataall =  this.adddataall.concat(res.data.obj)
					arrback.forEach(item=>{
						arr.push(item.key)
					})
					this.isaddatall=arr
					// console.log(this.isaddatall)
				});
			},
			/* 获取角色组列表 */
			getGroupListData(id){
				let params = id;
				this.$https.fetchPost('sys/admin/getRoleGroupByCompany', params).then(res => {
					this.rolalist=res.data.obj

				});
			},
			/* 获取公司列表 */
			getGroupCompanyList(id){
				let params = id;
				this.$https.fetchPost('sys/admin/getCompanyListByGroup', params).then(res => {
					this.AllCompanylist = res.data.obj;

				});
				},
			/* 	角色权限功能权限 */
			getRoleMenuFunctionList(id){
				let params = id;
				this.$https.fetchPost('sys/admin/getMenuIdListByRole', params).then(res => {
					this.cheackall=res.data.obj
				});
				this.$https.fetchPost('sys/admin/getRoleMenuFunctionList', params).then(res => {
					this.meauall=res.data.obj
				});

			},
			getUserByRoleId(roelId){
				this.isaddatall=[];
				let params = {
					search: {roleId:roelId},
					likeSearch: "",
					page: this.page,
					limit: this.pagenum
				};
				this.$https.fetchPost('sys/admin/getUserListByRole', params).then(res => {
					for (let i=0;i<res.data.data.length;i++){
						let data={};
						data.key=res.data.data[i].id
						data.label=res.data.data[i].userName
						this.isaddatall[i]=data
					}
				});
			}
	}
};
</script>

<style scoped="scoped" lang="less">
	/deep/.el-table--small td {
	    padding: 4px 0;
	}
	/deep/.el-table__body-wrapper {
		min-height: 160px;
	}
	.custom-tree-node{
		width: 300px;
		display: flex;
		justify-content: space-between;
		align-items: center;

	}
.topstyle {
	display: flex;
	justify-content: center;
}
.topstyle > span {
	margin-right: 20px;
}
.treeall {
}
.buttombut {
margin-top: 10px;
margin-bottom: 10px;
margin-left: 25px;
}
.bottomhalf {
	margin-top: 20px;
	height: 40vh;
	overflow: auto;
	border: 1px solid #e6e6e6;
}
.ara2-half {
	display: flex;
	justify-content: space-between;
	margin-top: 30px;
}
.ara1 {
	width: 40%;
	margin-left: 21px;
}
.ara2 {
	width: 56%;
}
.halfclass {
	display: flex;
	align-items: center;
}

</style>
